import { Theme } from '@mui/material/styles'

import createStyles from '@mui/styles/createStyles'
import makeStyles from '@mui/styles/makeStyles'

import dsgvoStyle from 'src/theme/dsgvoStyle'

const useStyles = makeStyles((theme: Theme) =>
  createStyles({

    container: {
      paddingTop: theme.spacing(4),
    },

    rootAusgeloggt: {

    },

    tabsAuswahl: {
      display: 'grid',
      gridTemplateColumns: 'repeat(2, 1fr)',
      gridGap: theme.spacing(2),
      marginTop: theme.spacing(3),
      marginBottom: theme.spacing(3),
    },

    loginForm: {
      marginTop: theme.spacing(3),
      display: 'grid',
      gridTemplateColumns: '1fr',
      gridGap: theme.spacing(2),
      maxWidth: '600px',
    },

    loginButton: {

    },

    rootRegistration: {

    },

    registerForm: {
      marginTop: theme.spacing(3),
      display: 'grid',
      gridTemplateColumns: '1fr',
      gridGap: theme.spacing(2),
      maxWidth: '600px',
    },

    dsgvoRecaptcha: dsgvoStyle(theme),

  })
)

export default useStyles
